import { PaymentSummary, SaleTransaction } from './transactionTypes';
import { getPaymentMethodFromNotes } from './paymentMethodUtils';

export const processSaleTransaction = (
  transaction: SaleTransaction,
  summariesMap: Map<string, PaymentSummary>
): void => {
  // Ne traiter que les transactions avec un montant payé
  if (transaction.paid_amount > 0 || transaction.total_amount > 0) {
    // Si c'est une transaction à crédit (pas entièrement payée)
    if (!transaction.is_fully_paid) {
      const method = "Crédit";
      let existing = summariesMap.get(method);
      if (!existing) {
        existing = { 
          method, 
          amount: 0, 
          transactions: [],
          isValidated: false
        };
        summariesMap.set(method, existing);
      }
      
      // Ajouter le montant total au crédit
      const totalAmount = transaction.total_amount || 0;
      existing.amount += totalAmount;

      if (!existing.transactions) {
        existing.transactions = [];
      }

      console.log("Ajout d'une transaction à crédit:", {
        id: transaction.id,
        date: transaction.created_at,
        amount: totalAmount,
        type: "credit_sale",
        notes: transaction.notes,
        remainingAmount: totalAmount - (transaction.paid_amount || 0)
      });

      // Ajouter la transaction avec le montant total
      existing.transactions.push({
        id: `${transaction.id}-credit`,
        date: transaction.created_at,
        amount: totalAmount,
        type: "credit_sale",
        notes: transaction.notes,
        remainingAmount: totalAmount - (transaction.paid_amount || 0)
      });

      // Ajouter les paiements de crédit s'ils existent
      if (transaction.credit_payments && transaction.credit_payments.length > 0) {
        transaction.credit_payments.forEach(payment => {
          console.log("Ajout d'un paiement de crédit:", {
            date: payment.payment_date,
            amount: payment.amount,
            type: "credit_payment"
          });

          existing.transactions?.push({
            id: `${transaction.id}-payment-${payment.payment_date}`,
            date: payment.payment_date,
            amount: payment.amount,
            type: "credit_payment",
            notes: `Paiement partiel de crédit`,
            remainingAmount: totalAmount - payment.amount
          });
        });
      }
      
      // Trier les transactions par date (plus récentes en premier)
      if (existing.transactions) {
        existing.transactions.sort((a, b) => 
          new Date(b.date).getTime() - new Date(a.date).getTime()
        );
      }
      
      summariesMap.set(method, existing);
      console.log("État final du summariesMap pour Crédit:", summariesMap.get("Crédit"));
      return;
    }

    // Pour les transactions complètement payées
    const method = getPaymentMethodFromNotes(transaction.notes || '');
    console.log("Transaction complète:", transaction);
    console.log("Mode de paiement détecté:", method);
    console.log("Notes de la transaction:", transaction.notes);
    
    let existing = summariesMap.get(method);
    if (!existing) {
      existing = { 
        method, 
        amount: 0, 
        transactions: [],
        isValidated: false
      };
      summariesMap.set(method, existing);
    }
    
    const amountToAdd = transaction.total_amount;
    existing.amount += amountToAdd;

    console.log(`Ajout d'une transaction ${method}:`, {
      date: transaction.created_at,
      amount: amountToAdd,
      type: "sale",
      notes: transaction.notes
    });

    if (!existing.transactions) {
      existing.transactions = [];
    }

    existing.transactions.push({
      id: `${transaction.id}-sale`,
      date: transaction.created_at,
      amount: amountToAdd,
      type: "sale",
      notes: transaction.notes
    });
    
    // Trier les transactions par date (plus récentes en premier)
    if (existing.transactions) {
      existing.transactions.sort((a, b) => 
        new Date(b.date).getTime() - new Date(a.date).getTime()
      );
    }
    
    summariesMap.set(method, existing);
    console.log("État final du summariesMap pour", method, ":", summariesMap.get(method));
  }
};